<template>
  <a-image 
    :src="cachedSrc" 
    :alt="alt"
    :preview="preview"
    :width="width"
    :height="height"
    :placeholder="placeholder"
    :fallback="fallback"
    @click="handleClick"
    @load="handleLoad"
    @error="handleError"
  />
</template>

<script setup>
import { ref, watch } from 'vue'
import imageCache from '@/utils/imageCache-http'

const props = defineProps({
  src: {
    type: String,
    required: true
  },
  alt: {
    type: String,
    default: ''
  },
  preview: {
    type: Boolean,
    default: undefined
  },
  width: {
    type: [String, Number],
    default: undefined
  },
  height: {
    type: [String, Number],
    default: undefined
  },
  placeholder: {
    type: Boolean,
    default: undefined
  },
  fallback: {
    type: String,
    default: ''
  },
  autoCache: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['click', 'load', 'error'])

const cachedSrc = ref(props.src)

// 获取缓存的图片URL
const getCachedSrc = async () => {
  if (!props.src) return props.src
  
  try {
    if (props.autoCache) {
      const blobUrl = await imageCache.getImageBlob(props.src)
      cachedSrc.value = blobUrl
    } else {
      cachedSrc.value = props.src
    }
  } catch (error) {
    console.warn('图片缓存失败，使用原始URL:', error)
    cachedSrc.value = props.src
  }
}

// 监听src变化
watch(() => props.src, (newSrc) => {
  if (newSrc) {
    getCachedSrc()
  }
}, { immediate: true })

// 事件处理
const handleClick = (e) => {
  emit('click', e)
}

const handleLoad = (e) => {
  emit('load', e)
}

const handleError = (e) => {
  emit('error', e)
}

// 暴露方法给父组件
defineExpose({
  getCachedSrc,
  refreshCache: getCachedSrc
})
</script>

<style scoped>
/* 继承a-image的样式 */
</style>
